<script lang="ts">
	import {
		DashControlWidget,
		type DashDeviceWidgetPropsTypes,
	} from '@Shelly/shelly-design-system/index';
	import TimerAlarmDelay from 'src/components/Lists/Alarms/components/TimerAlarmDelay.svelte';
	import ControlAlarm from 'src/components/Lists/Alarms/ControlAlarm.svelte';
	import type { AlarmDelayModalType, AlarmDelayTimerType } from 'src/components/Lists/list-helpers';
	import { load_image_from } from 'src/helpers/interface_helpers';
	import { alarms } from 'src/stores/lists/scenes-derived';
	import { edit } from 'src/stores/ui/edit_lists';
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { format } from 'svelte-i18n';

	export let alarmWidget;

	let alarmsDelayModal: AlarmDelayModalType = {};
	let alarmsDelayTimer: AlarmDelayTimerType = {};
	let hasMissingDevice = false;
	let additionalText: DashDeviceWidgetPropsTypes['additionalText'] = {
		value: '',
	};

	$: alarm = $alarms[alarmWidget.id];

	$: value = !alarm ? alarmWidget?.id : alarm?._meta.name;

	$: avatar = !alarm
		? { icon: 'fat fa-triangle-exclamation text-color-warning' }
		: {
				backgroundColor: alarm?._meta?.backgroundColor,
				image: alarm?._meta?.image ? load_image_from(alarm?._meta.image) : '',
			};
	$: additionalText = !alarm
		? {
				value: $format('label_missing_alarm', {
					default: 'Missing Alarm',
				}),
				type: 'warning',
			}
		: {
				value: hasMissingDevice
					? $format('label_missing_device', {
							default: 'Missing Device',
						})
					: '',
				icon: hasMissingDevice ? 'fa-light fa-triangle-exclamation' : '',
				type: hasMissingDevice ? 'warning' : undefined,
			};
</script>

<DashControlWidget
	aria-label="Dash Control Widget"
	class="cursor-pointer"
	{value}
	{avatar}
	{additionalText}
	selected={alarmWidget?.id === $sidePanelStateCombined?.id}
	hideSlotRight={$edit || !alarm}
	on:click
>
	<svelte:fragment slot="right">
		<TimerAlarmDelay
			{alarm}
			hideLabel
			bind:showModal={alarmsDelayModal[alarm?.id]}
			bind:timer={alarmsDelayTimer[alarm?.id]}
			bind:hasMissing={hasMissingDevice}
		/>
		<ControlAlarm
			item={alarm}
			isOnDashWidget
			on:alarmDelayStart={(e) => {
				alarmsDelayModal[alarm?.id] = !!e.detail;
			}}
		/>
	</svelte:fragment>
</DashControlWidget>
